'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');
require('../../composites/Card/Card.js');
require('../../composites/Card/CardImage/CardImage.js');
require('../../composites/Card/CardText/CardText.js');
require('../../composites/Card/CardTitle/CardTitle.js');
var Carousel = require('../../composites/Carousel/Carousel.js');
require('../../composites/Carousel/CarouselControl/CarouselControl.js');
require('../../composites/Carousel/CarouselIndicator/CarouselIndicator.js');
require('../../composites/Carousel/CarouselIndicators/CarouselIndicators.js');
require('../../composites/Carousel/CarouselItem/CarouselItem.js');
var CarouselInner = require('../../composites/Carousel/CarouselInner/CarouselInner.js');
require('../../composites/EventCard/EventCard.js');
require('../../composites/EventCard/EventGrid/EventGrid.js');
require('../../composites/Modal/Modal.js');
require('../../composites/Modal/ModalBody/ModalBody.js');
require('../../composites/Modal/ModalFooter/ModalFooter.js');
require('../../composites/Modal/ModalHeader/ModalHeader.js');
require('../../composites/SearchBar/SearchBar.js');
require('../../composites/Video/Video.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var FeatureCarousel = function FeatureCarousel(props) {
  var length = props.length,
    indicatorLabels = props.indicatorLabels,
    children = props.children,
    className = props.className,
    activeItem = props.activeItem,
    controlsColor = props.controlsColor;
  var bannerClasses = index.default('lanl-featured-carousel', className);
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: bannerClasses,
    "data-testid": "lanl-featured-carousel"
  }, /*#__PURE__*/React__default.default.createElement(Carousel.Carousel, {
    activeItem: activeItem,
    length: length,
    controlsColor: controlsColor,
    controlsOutside: false,
    loop: true,
    showControls: true,
    showIndicators: true,
    slide: true,
    indicatorLabels: indicatorLabels
  }, /*#__PURE__*/React__default.default.createElement(CarouselInner.CarouselInner, null, children)));
};
FeatureCarousel.defaultProps = {
  activeItem: 0,
  controlColors: 'white',
  indicatorLabels: []
};
FeatureCarousel.propTypes = {
  children: PropTypes__default.default.node.isRequired,
  length: PropTypes__default.default.number.isRequired,
  activeItem: PropTypes__default.default.number,
  className: PropTypes__default.default.string,
  controlsColor: PropTypes__default.default.oneOf(['white', 'standard']),
  indicatorLabels: PropTypes__default.default.arrayOf(PropTypes__default.default.string)
};

exports.FeatureCarousel = FeatureCarousel;
exports.default = FeatureCarousel;
//# sourceMappingURL=FeatureCarousel.js.map
